import React from 'react';
import fileDownload from 'js-file-download';
import FolderIcon from '@mui/icons-material/Folder';

import { axiosApi } from '../../../util/axiosApi';
import { limitText } from '../../SearchPage/components/NewsSearchSection/utils';

import PdfPreview from '../../../components/PdfPreview/PdfPreview';
import ImagePreview from '../../../components/ImagePreview/ImagePreview';

import css from './FilesSection.module.css';

const Item = (props) => {
  const {
    file,
  } = props;

  const handleDownloadFile = () => {
    axiosApi.get(`/aws/download?key=${file.key}`, {
      responseType: 'blob',
    })
      .then(resp => {
        fileDownload(resp.data, file.name);
      })
      .catch(error => {
        console.log(error);
      });
  };

  let content;

  const isImage = file?.type?.includes('image')
  const isPdf = file?.type?.includes('pdf')
  const canDownload = !(isImage || isPdf)

  if (isImage) {
    content = <ImagePreview file={file} />;
  } else if (isPdf) {
    content = <PdfPreview file={file} />;
  } else {
    content = (
      <>
        <div className={css.folderIcon}>
          <FolderIcon className={css.icon} />
        </div>
        <span>{limitText(file?.description || file?.name, 15)}</span>
      </>
    );
  }

  return (
    <div
      className={css.document}
      title='Download'
      onClick={canDownload && handleDownloadFile}
    >
      {content}
    </div>
  );
};

export default Item;
